import { atom } from "recoil";
import { Order } from "../model/Order";
import { SelectOptions, UserComment } from "../model/Base";
import { OrderPdf } from "../model/OrderPdf";
import { WorkFlowType } from "../model/enums/Constants";
 
export const orderState = atom<Order>({
	key: "orderState",
	default: new Order()
});

export const orderPdfState = atom<OrderPdf>({
	key: "orderPdfState",
	default: new OrderPdf()
});


export const forestAreaState = atom<SelectOptions[]>({
	key: "forestAreaState",
	default : undefined
});

export const orderWorkFlowState = atom<string>({
	key: "orderWorkFlowState",
	default: WorkFlowType.REQUESTER
});

export const commentsState = atom<UserComment[]>({
	key: "commentsState",
	default: undefined
});